import Modal from "bootstrap/js/dist/modal";
import { isMobileUserAgent, stringToBoolean } from "./utils";

export function openCopyReportModal() {
    if (isMobileUserAgent()) {
        return;
    }

    const copyReportModalElement = document.querySelector(".copy-report-modal");

    if (!copyReportModalElement) {
        return;
    }

    const prompt = stringToBoolean(copyReportModalElement?.dataset?.prompt);
    const promptModal = Modal.getOrCreateInstance(
        `#${copyReportModalElement.id}`
    );

    if (prompt && promptModal) {
        promptModal.show();
    }
}
